import React from "react";
import { Eye, FileText, CheckCircle, Shield } from "lucide-react";
import FeatureItem from "./FeatureItem";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const TransparencyContent = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const contentData =
    labels.menuPages?.buyCar?.transparencySection?.content || {};
  const featuresData = contentData.features || [];

  const icons = [Eye, FileText, CheckCircle, Shield];
  const colors = [
    "from-blue-500 to-cyan-500",
    "from-green-500 to-emerald-500",
    "from-purple-500 to-pink-500",
    "from-orange-500 to-red-500",
  ];

  const features = featuresData.map((feature: any, index: number) => {
    const Icon = icons[index] || icons[0];
    return {
      icon: <Icon className="w-6 h-6" />,
      title: feature.title || "",
      description: feature.description || "",
      color: colors[index] || colors[0],
    };
  });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-center mb-8 md:mb-12 max-w-6xl mx-auto">
      <div className="order-2 lg:order-1">
        <img
          src="/assets/test_example.png"
          alt="Fordonstestrapport med transparent dokumentation för Volkswagen Tiguan"
          className="w-full h-auto rounded-xl md:rounded-2xl shadow-lg"
          loading="lazy"
        />
      </div>

      <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
        {features.map((feature, index) => (
          <FeatureItem key={index} feature={feature} index={index} />
        ))}
      </div>
    </div>
  );
};

export default TransparencyContent;
